import React, { useCallback, useMemo } from 'react'

import { NotificationStatus } from 'contexts/notification/types'

import { NotificationCard } from 'components/Notification/NotificationCard'

import { Box, Divider, Stack, Text } from '@chakra-ui/react'
import { useNotification } from 'contexts/notification'
import { Footer } from '../Footer'

export const TabFavorite = () => {
  const { favoriteNotifications, nextPage, prevPage } = useNotification()

  const meta = useMemo(() => {
    if (!favoriteNotifications) {
      return []
    }

    const draftUnread = favoriteNotifications[NotificationStatus.UNREAD]
    const draftRead = favoriteNotifications[NotificationStatus.READ]

    const metadata = []
    if (draftUnread) {
      metadata.push(draftUnread.meta)
    }

    if (draftRead) {
      metadata.push(draftRead.meta)
    }

    return metadata
  }, [favoriteNotifications])

  const notificationsUnread = useMemo(() => {
    if (!favoriteNotifications) {
      return null
    }

    const draft = favoriteNotifications[NotificationStatus.UNREAD]

    if (!draft) {
      return null
    }

    return draft.data
  }, [favoriteNotifications])

  const notificationsRead = useMemo(() => {
    if (!favoriteNotifications) {
      return null
    }

    const draft = favoriteNotifications[NotificationStatus.READ]

    if (!draft) {
      return null
    }

    return draft.data
  }, [favoriteNotifications])

  const isBlank = useMemo(() => {
    if (!notificationsUnread && !notificationsRead) {
      return true
    }

    if (notificationsUnread?.length === 0 && notificationsRead?.length === 0) {
      return true
    }

    return false
  }, [notificationsRead, notificationsUnread])

  const handleNextPage = useCallback(() => {
    nextPage(NotificationStatus.READ)
    nextPage(NotificationStatus.UNREAD)
  }, [nextPage])

  const handlePrevPage = useCallback(() => {
    prevPage(NotificationStatus.READ)
    prevPage(NotificationStatus.UNREAD)
  }, [prevPage])

  return (
    <Box>
      {isBlank ? (
        <Text
          pt="6"
          pb="3"
          display="flex"
          fontSize="xs"
          fontWeight="thin"
          fontStyle="italic"
          alignItems="center"
          justifyContent="center"
        >
          Nenhuma mensagem favoritada
        </Text>
      ) : (
        <>
          {notificationsUnread && (
            <Stack boxShadow="md" mb="2.5" divider={<Divider />}>
              {notificationsUnread.map((notification) => (
                <NotificationCard key={notification.id} data={notification} />
              ))}
            </Stack>
          )}

          {notificationsRead && (
            <Stack divider={<Divider />}>
              {notificationsRead.map((notification) => (
                <NotificationCard key={notification.id} data={notification} />
              ))}
            </Stack>
          )}
        </>
      )}

      <Footer
        meta={meta}
        onNextPage={handleNextPage}
        onPrevPage={handlePrevPage}
      />
    </Box>
  )
}
